import { render } from "./New.vue?vue&type=template&id=01a9508b&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"

import "./New.vue?vue&type=style&index=0&id=01a9508b&scoped=true&lang=css"
import "./New.vue?vue&type=style&index=1&id=01a9508b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a9508b"]])

export default __exports__